import CommonAdapter from '../../adapters/CommonAdapter';
import EnhancedLocation from 'owa-service/lib/contract/EnhancedLocation';
import LocationDetails from './LocationDetails';
import { ApiMethodCallback } from '../ApiMethod';
import { createLocationDetails } from './enhancedLocationsUtils';
import { createSuccessResult } from '../ApiMethodResponseCreator';
import { getAdapter } from '../../adapters/AdapterManager';

export default function getEnhancedLocationsAsyncApiMethod(
    hostItemIndex: string,
    controlId: string,
    data: null,
    callback: ApiMethodCallback
) {
    const adapter = getAdapter(hostItemIndex) as CommonAdapter;
    const enhancedLocations: EnhancedLocation[] = adapter.getEnhancedLocations();

    if (!enhancedLocations || enhancedLocations.length <= 0) {
        callback(createSuccessResult([]));
        return;
    }
    const locationDetails: LocationDetails[] = enhancedLocations.map(createLocationDetails);
    callback(createSuccessResult(locationDetails));
}
